export const RoleTwelveOther = [
    {
        title: 'Resumen General',
        url: '/index/client-event',
        base: '',
        icon: 'notifications',
        alert: false
    },
]